import { render, staticRenderFns } from "./MattReI_Section.vue?vue&type=template&id=68bf0497"
import script from "./MattReI_Section.vue?vue&type=script&lang=js"
export * from "./MattReI_Section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports